import React from 'react';

import { StreamSearchContext } from './StreamSearchContext';

export const useStreamSearchContext = () => React.useContext(StreamSearchContext);
